import "packs/public-path";
import { loadLocale } from "flavours/glitch/locales";
import { applyPreferredLocale } from "flavours/glitch/locales/preferred_locale";
import main from "flavours/glitch/main";
import { loadPolyfills } from "flavours/glitch/polyfills";

// Must run before the polyfills and the locale are loaded, as both read <html lang>.
applyPreferredLocale();

loadPolyfills()
  .then(loadLocale)
  .then(main)
  .catch(e => {
    console.error(e);
  });
